export default __webpack_public_path__ + "static/media/loan-origination-system.be9be28b.svg";